import { TIER_NAMES, type TrialOffer } from "../../lib/api";

/**
 * THE TRIAL AT EVERY CONVERSION GATE (owner, 2026-10-06; ruling R-1006-2).
 *
 * A Free account that meets a wall — talking to its own Nob, a knock the plan
 * could not cover, the console's locked bar — is offered the trial FIRST while
 * one is on offer, and the paid plans are the second road. The offer is whatever
 * `GET /plan` reports as `trial` (the plan room's "Start the trial" control and
 * the console's quiet link read the same field); with none — spent, refused for
 * risk, plans dark — every gate says what it always said.
 *
 * The control only OPENS the plan room at the trial's consent. The consent
 * stays where it lives, so there is no second checkout surface here.
 *
 * NO FIGURE, NO CAPACITY (ruling C2): the line under the control is built from
 * the offer's own tier and length, the way the trial screen names it, and says
 * nothing about what the trial holds. And nothing here says the trial is needed
 * for a door to work — a Free door works like any other.
 */
export const START_TRIAL = "Start your free trial";
export const SEE_THE_PLANS = "See the plans";

/** "7 days of Personal" — the offer, in the trial screen's own terms. */
export function trialOfferLine(offer: TrialOffer): string {
  return `${offer.days} days of ${TIER_NAMES[offer.tier]}`;
}
